import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import { getAppointmentStatusColor } from '../../../../utilities/appointments';
import { useDispatch } from 'react-redux';
import { storeInLocal } from '../../../../lib/storage';
import { useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import { formatEncounterStatus } from '../../utils/encounterHelper';
import dayjs from 'dayjs';
import moment from 'moment';
import { SummaryLoading } from '../PastEncounter/SummaryLoading';
import CreateEncounterModalFlexible from './CreateEncounterModalFlexible';

const AuraFullCalendar = ({
  dataSource,
  selectedEncounterSlice,
  setEncounterStatus,
  setPageState,
  setStartDate,
  setEndDate,
  setIsCustomSelected,
  setSelectedDate,
  auraView,
  startDate,
  changeEncounterStatus,
  setRecord,
  handleCalendarEventClick,
  handleCalendarEventDateChange,
  endDate,
}) => {
  const dispatch = useDispatch();
  const viewChange = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const { isEncounterUpdateLoading } = useSelector(
    (state) => state?.encounterState
  );

  const [dateInfo, setDateInfo] = useState();
  const [currentViewInfo, setCurrentViewInfo] = useState();

  const convertToISO = (dateString) => {
    const formattedDateString = dateString.replace(/(\.\d{6})/, '');
    const date = new Date(formattedDateString);
    return date.toISOString();
  };

  const mapToFullCalendarEvents = (dataSource = []) => {
    if (!dataSource || !dataSource.length) {
      return;
    }
    return dataSource.map((item) => {
      const dateStr = convertToISO(item.start_time);
      const title = item.description;

      return {
        id: item.encounter_id,
        title,
        start: dateStr,
        encounter_id: item.encounter_id,
        encounter_status: item.encounter_status,
        patient_id: item.patient_id,
        practitioner_Name: item.practitioner_Name,
        classNames: 'p-1',
        backgroundColor: formatEncounterStatus(item)?.color,
        textColor: getAppointmentStatusColor(item.encounter_status).textColor,
        ...item,
      };
    });
  };

  const handleDateFilterChange = (value) => {
    dispatch(selectedEncounterSlice(null));
    setEncounterStatus('');

    if (Array.isArray(value) && value.length === 2) {
      const [startDate, endDate] = value;
      setPageState({
        current: 1,
        pageSize: auraView === 'LIST' ? 10 : 100,
      });
      setStartDate(startDate);
      setEndDate(endDate);
      setIsCustomSelected(true);
      setSelectedDate('Custom…🗓️');
      storeInLocal(
        `${currentPractitioner?.org_uuid}_selectedDate`,
        'Custom…🗓️'
      );
    } else {
      setPageState({
        current: 1,
        pageSize: auraView === 'LIST' ? 10 : 100,
      });
      setIsCustomSelected(false);
      setSelectedDate(value);
      if (startDate || endDate) {
        setStartDate(null);
        setEndDate(null);
      }
    }
  };

  const handleDateRangeSelect = (startDate, endDate) => {
    handleDateFilterChange([startDate, endDate]);
  };

  const handleViewChange = (viewInfo) => {
    let startDate = viewInfo.start;
    let endDate = viewInfo.end;

    // Store current view info for use in callback
    setCurrentViewInfo({
      start: startDate,
      end: endDate,
      viewType: viewInfo?.view?.type,
    });

    handleDateRangeSelect(startDate, endDate);
    mapToFullCalendarEvents(dataSource);
  };

  const fullCalendarEvents = mapToFullCalendarEvents(dataSource);

  const callback = (createdEncounter) => {
    setRecord(createdEncounter);
    changeEncounterStatus(createdEncounter?.encounter_id);

    if (currentViewInfo) {
      handleDateRangeSelect(currentViewInfo.start, currentViewInfo.end);
    }
  };

  const createEncounterCalendar = (info) => {
    setDateInfo(info);
    setIsOpen(true);
  };

  const handleEventDrop = (info) => {
    const inputDate = new Date(info.event.start);
    const momentDate = moment
      .utc(inputDate, ' MM-DD-YYYY hh:mm A')
      .utcOffset(330);
    const currentTime = dayjs();

    const finalDate = momentDate
      .hour(currentTime.hour())
      .minute(currentTime.minute())
      .second(currentTime.second())
      .millisecond(currentTime.millisecond());

    const formattedDate = finalDate.toISOString();
    const eventRecord = info?.event?.extendedProps;
    handleCalendarEventDateChange(formattedDate, eventRecord);
  };

  return isEncounterUpdateLoading ? (
    <SummaryLoading />
  ) : (
    <div id="calendar">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        droppable={true}
        editable={true}
        eventDrop={handleEventDrop}
        headerToolbar={{
          left: 'prev next',
          center: 'title',
          right: 'timeGridDay,timeGridWeek,dayGridMonth',
        }}
        eventClick={(event) => {
          handleCalendarEventClick(event?.event?.extendedProps);
        }}
        events={fullCalendarEvents}
        ref={viewChange}
        initialView="dayGridMonth"
        datesSet={handleViewChange}
        dateClick={(info) => {
          createEncounterCalendar(info);
        }}
        dayMaxEvents={6}
        handleWindowResize={true}
      />

      <CreateEncounterModalFlexible
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        callback={callback}
        dateInfo={dateInfo}
      />
    </div>
  );
};

export default AuraFullCalendar;
